// extracted by mini-css-extract-plugin
export default {"page":"aX-z","cartModal":"bX-z","checkout":"cX-z","placeholder":"dX-z","account":"eX-z"};